import { FavouriteSearchBar } from 'components/search-bar-fav/searchbar-fav.js';
import * as React from 'react';
import { SearchBarInput } from './search-bar-input.js';
export const SEARCH_BAR_DEFAULT_TEXT = 'Search for a location';

/** This has to be memoized to prevent multiple re-renders via the parent updating div position via js */
const SearchBar = () => {
  return (
    <div className="SearchBar domRef">
      <SearchBarInput />
      <FavouriteSearchBar />
    </div>
  );
};

export const MemoSearchBar = React.memo(SearchBar);
